import { PlusOutlined } from '@ant-design/icons';
import {
  ColorInput,
  DecimalInput,
  FormErrorsAlert,
  FormHandler,
  FormItem,
  NumberInput,
  RelationEditor,
  TextInput,
} from '@framework/form';
import { Drawer, DrawerButtonRow } from '@framework/ui';
import { Button, Space, message } from 'antd';
import * as React from 'react';
import { MapLayerType } from '../../layers/MapLayer';
import { MapLayersConfigSection } from '../MapLayersConfigSection';
import { IMapPrintImage } from './MapPrintImage';
import { MapPrintImageSchema } from './MapPrintImageSchema';

export interface IMapPrintImageConfigDrawerButtonProps {
  editor: RelationEditor<IMapPrintImage>;
}

export function MapPrintImageConfigDrawerButton(
  props: IMapPrintImageConfigDrawerButtonProps,
) {
  const { editor } = props;
  return (
    <div>
      <Button
        type="dashed"
        block
        size="large"
        icon={<PlusOutlined aria-hidden="true" />}
        onClick={e => {
          editor.handle.open(MapPrintImageSchema.cast({}, { assert: false }));
          e.stopPropagation();
        }}
      >
        Aggiungi Immagine in Stampa
      </Button>
      {/* Modal Drawer  */}
      <Drawer
        title={
          editor.handle.isNew
            ? 'Crea Immagine in Stampa'
            : 'Modifica Immagine in Stampa'
        }
        size="large"
        placement="right"
        onClose={editor.handle.cancel}
        open={editor.handle.isVisible}
      >
        <FormHandler
          nested
          layout="vertical"
          schema={MapPrintImageSchema}
          initialValues={
            editor.handle.current ??
            MapPrintImageSchema.cast({}, { assert: false })
          }
          onSubmit={async (values, e) => {
            try {
              const type = editor.handle.apply(values);
              if (type === 'updated') {
                message.success('Immagine di Stampa modificata');
              } else {
                message.success('Immagine di Stampa aggiunta');
              }
            } catch (e) {
              message.error(
                "Si è verificato un errore nella modifica dell'immagine",
              );
              console.error(e);
            }
          }}
        >
          <FormErrorsAlert />
          <FormItem name="name" label="Nome" help="Riferimento ad uso interno">
            <TextInput name="name" />
          </FormItem>

          <MapLayersConfigSection
            name="layers"
            allowedTypes={[
              MapLayerType.ArcGISRestTile,
              MapLayerType.XYZ,
              MapLayerType.WMS,
              MapLayerType.OSM,
            ]}
          />

          <FormItem
            label="Padding"
            name={`padding`}
            help="Spazio di margine intorno alle geometrie"
          >
            <NumberInput min={0} name={`padding`} />
          </FormItem>

          <FormItem label="Colore di riempimento" name={`fillColor`}>
            <ColorInput name={`fillColor`} />
          </FormItem>
          <FormItem
            label="Opacità del riempimento"
            name={`fillOpacity`}
            help="Un valore pari a 0 renderizza il riempimento completamente trasparente, un valore pari a 1 completamente opaco"
          >
            <DecimalInput min={0} max={1} name={`fillOpacity`} />
          </FormItem>
          <FormItem label="Colore del bordo" name={`strokeColor`}>
            <ColorInput name={`strokeColor`} />
          </FormItem>
          <FormItem label="Spessore del bordo" name={`strokeWidth`}>
            <NumberInput min={0} name={`strokeWidth`} />
          </FormItem>
          <FormItem
            label="Opacità del bordo"
            name={`strokeOpacity`}
            help="Un valore pari a 0 renderizza il bordo completamente trasparente, un valore pari a 1 completamente opaco"
          >
            <DecimalInput min={0} max={1} name={`strokeOpacity`} />
          </FormItem>

          <DrawerButtonRow>
            <Space>
              <Button size="large" onClick={editor.handle.cancel}>
                Annulla
              </Button>
              <Button type="primary" htmlType="submit" size="large">
                Applica
              </Button>
            </Space>
          </DrawerButtonRow>
        </FormHandler>
      </Drawer>
    </div>
  );
}
